<div class="ui-stock-selector">
  <ui-autocomplete-field
    [label]="categoryLabel()"
    [value]="selectedCategoryText()"
    [options]="categories()"
    [emptyMessage]="'No categories found.'"
    (valueChange)="onCategoryQuery($event)"
    (optionSelected)="selectCategory($event)"
  ></ui-autocomplete-field>

  <ui-autocomplete-field
    [label]="productLabel()"
    [value]="selectedProductText()"
    [options]="filteredProducts()"
    [disabled]="!value().categoryId"
    [hint]="!value().categoryId ? 'Select a category first.' : ''"
    [emptyMessage]="'No products found.'"
    (valueChange)="onProductQuery($event)"
    (optionSelected)="selectProduct($event)"
  ></ui-autocomplete-field>

  <ui-autocomplete-field
    [label]="variantLabel()"
    [value]="selectedVariantText()"
    [options]="filteredVariants()"
    [disabled]="!value().productId"
    [hint]="!value().productId ? 'Select a product first.' : ''"
    [emptyMessage]="'No variants found.'"
    (valueChange)="onVariantQuery($event)"
    (optionSelected)="selectVariant($event)"
  ></ui-autocomplete-field>

  <ui-form-field
    [label]="quantityLabel()"
    type="number"
    min="1"
    [required]="true"
    [value]="value().quantity === null ? '' : '' + value().quantity"
    [error]="quantityError()"
    (valueChange)="setQuantity($event)"
  ></ui-form-field>
</div>
